import { render, staticRenderFns } from "./boards-toolbar.vue?vue&type=template&id=1e1ea07c"
import script from "./boards-toolbar.vue?vue&type=script&lang=js"
export * from "./boards-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports